import { c as _c } from "react/compiler-runtime";
import { Trans, useTranslation } from 'react-i18next';
import IconChip from '@/assets/icons/heroIcons/Chip.svg';
import IconShieldExclamation from '@/assets/icons/heroIcons/ShieldExclamation.svg';
import IconShoppingBag from '@/assets/icons/heroIcons/Shopping-bag.svg';
import IconShoppingCart from '@/assets/icons/heroIcons/Shopping-cart.svg';
import IconRewards from '@/assets/icons/heroIcons/Rewards.svg';
import IconThird from '@/assets/icons/heroIcons/Third.svg';
import IconChat from '@/assets/icons/heroIcons/Chat.svg';
import IconGift from '@/assets/icons/heroIcons/Gift.svg';
import React, { ReactNode, useState } from 'react';
import { FilledButton } from '@/components/buttons';
import { SectionHeadline } from '@/components/SectionHeadline';
import { useSheet } from '@/components/Sheet/Sheet';
import { MOBILE_SHEET_BOTTOM_PADDING, MOBILE_SHEET_HEADER_HEIGHT } from '@/components/inputs';
import { Link } from '@/components/links';
import { LINKS } from '@/constants/links';
import { CallMeForm } from '@/components/CallMeForm';
import { Modal } from '@/components/modal';
import { Text } from '@/components/typography';
import useMediaQuery from '@/hooks/useMediaQuery';
import { getMediaQuery } from '@/styles/sizes';
const FormContact = t0 => {
  const $ = _c(27);
  const {
    title,
    text,
    description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["retention"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== title) {
    t2 = <h3 className="mb-4 text-3xl font-bold lg:text-4xl">{title}</h3>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== text) {
    t3 = <p className="text-sm lg:text-base">{text}</p>;
    $[3] = text;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("dissatisfaction.form.title");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <h4 className="font-semibold">{t4}</h4>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("dissatisfaction.form.text");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <p className="mb-4 text-sm lg:text-base">{t6}</p>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== description) {
    t8 = <CallMeForm type="REVOLVING_LOAN_CANCELLATION_REQUEST" description={description} hideRetentionButton={true} id="dissatisfactionForm" className="w-full sm:flex-row sm:items-center" />;
    $[13] = description;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t5 || $[16] !== t7 || $[17] !== t8) {
    t9 = <div className="my-8 lg:my-10">{t5}{t7}{t8}</div>;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Link testId="informationMemorandum" analyticsParam="informationMemorandum" to={LINKS().informationMemorandum} />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = <p className="text-light-gray-500 text-xs"><Trans t={t} i18nKey="dissatisfaction.form.conditions">{t10}</Trans></p>;
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t2 || $[24] !== t3 || $[25] !== t9) {
    t12 = <>{t2}{t3}{t9}{t11}</>;
    $[22] = t11;
    $[23] = t2;
    $[24] = t3;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
type option = 'technical' | 'distrust' | 'fewEshops' | 'lowLimit' | 'firstDiscountOnly' | 'fewRewards' | 'lowLimitThree' | 'other';
export function Dissatisfaction(t0) {
  const $ = _c(137);
  const {
    handleScrollToContact
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["retention"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const [selectedType, setSelectedType] = useState("technical");
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = getMediaQuery("md");
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isResponsive = useMediaQuery(t2);
  let t3;
  if ($[2] !== selectedType || $[3] !== t) {
    t3 = function renderText() {
      switch (selectedType) {
        case "fewEshops":
          {
            return <Trans t={t} i18nKey="dissatisfaction.items.fewEshops.form.text"><Link testId="retentionWhereToShop" analyticsParam="retentionWhereToShop" to={LINKS().whereToShop} /><Link testId="retentionPayInThree" analyticsParam="retentionPayInThree" to={LINKS().payInThree} /><Link testId="retentionCard" analyticsParam="retentionCard" to={LINKS().card} /></Trans>;
          }
        case "lowLimit":
          {
            return <Trans t={t} i18nKey="dissatisfaction.items.lowLimit.form.text"><Link testId="retentionPackages" analyticsParam="retentionPackages" to={LINKS().packages} /></Trans>;
          }
        case "firstDiscountOnly":
          {
            return <Trans t={t} i18nKey="dissatisfaction.items.firstDiscountOnly.form.text"><Link testId="retentionInsurance" analyticsParam="retentionInsurance" to={LINKS().insurance} /><Link testId="retentionRewards" analyticsParam="retentionRewards" to={LINKS().rewards} /></Trans>;
          }
        case "fewRewards":
          {
            return <Trans t={t} i18nKey="dissatisfaction.items.fewRewards.form.text"><Link testId="retentionRewards" analyticsParam="retentionRewards" to={LINKS().rewards} /></Trans>;
          }
        default:
          {
            return t(`dissatisfaction.items.${selectedType}.form.text`);
          }
      }
    };
    $[2] = selectedType;
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const renderText = t3;
  let t4;
  if ($[5] !== renderText || $[6] !== selectedType || $[7] !== t) {
    t4 = () => <div className="max-h-[90vh] overflow-auto px-5"><FormContact title={t(`dissatisfaction.items.${selectedType}.form.title`)} text={renderText()} description={t(`dissatisfaction.items.${selectedType}.title`)} /></div>;
    $[5] = renderText;
    $[6] = selectedType;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      withCloseIcon: true,
      closeOnSelect: false,
      snapPoints: [560 + MOBILE_SHEET_HEADER_HEIGHT + MOBILE_SHEET_BOTTOM_PADDING]
    };
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const [sheet, openSheet] = useSheet(t4, t5);
  let t6;
  if ($[10] !== isResponsive || $[11] !== openSheet) {
    t6 = function handleSelectOption(id) {
      setSelectedType(id);
      if (isResponsive) {
        setIsModalOpen(true);
      } else {
        openSheet();
      }
    };
    $[10] = isResponsive;
    $[11] = openSheet;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleSelectOption = t6;
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => setIsModalOpen(false);
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `dissatisfaction.items.${selectedType}.form.title`;
  let t9;
  if ($[14] !== t || $[15] !== t8) {
    t9 = t(t8);
    $[14] = t;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== renderText) {
    t10 = renderText();
    $[17] = renderText;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = `dissatisfaction.items.${selectedType}.title`;
  let t12;
  if ($[19] !== t || $[20] !== t11) {
    t12 = t(t11);
    $[19] = t;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t10 || $[23] !== t12 || $[24] !== t9) {
    t13 = <FormContact title={t9} text={t10} description={t12} />;
    $[22] = t10;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== isModalOpen || $[27] !== t13) {
    t14 = <Modal analyticsParam="withdrawalModal" testId="withdrawalModal" modalName="WithdrawalModal" isVisible={isModalOpen} onClose={t7} className="max-w-[60.5rem]! overflow-hidden rounded-2xl p-4 pb-8 md:rounded-4xl md:p-14 md:pr-16 md:pl-14">{t13}</Modal>;
    $[26] = isModalOpen;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("dissatisfaction.title");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t15) {
    t16 = <SectionHeadline className="mb-4 lg:mb-6" variant="inverted" anchorKey="dissatisfaction.title">{t15}</SectionHeadline>;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t) {
    t17 = t("dissatisfaction.text");
    $[33] = t;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t17) {
    t18 = <Text className="text-light-gray-100 mb-10 text-center lg:mb-16" variant="p2">{t17}</Text>;
    $[35] = t17;
    $[36] = t18;
  } else {
    t18 = $[36];
  }
  let t19;
  if ($[37] !== t16 || $[38] !== t18) {
    t19 = <div className="mx-auto max-w-192">{t16}{t18}</div>;
    $[37] = t16;
    $[38] = t18;
    $[39] = t19;
  } else {
    t19 = $[39];
  }
  let t20;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconChip className="fillButtonIcon" />;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  let t21;
  if ($[41] !== t) {
    t21 = t("dissatisfaction.items.technical.title");
    $[41] = t;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t) {
    t22 = t("dissatisfaction.items.technical.text");
    $[43] = t;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== handleSelectOption) {
    t23 = () => handleSelectOption("technical");
    $[45] = handleSelectOption;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== t21 || $[48] !== t22 || $[49] !== t23) {
    t24 = {
      analyticsParam: "retentionDissatisfactionTechnical",
      icon: t20,
      testId: "retentionDissatisfactionTechnical",
      title: t21,
      text: t22,
      onClick: t23
    };
    $[47] = t21;
    $[48] = t22;
    $[49] = t23;
    $[50] = t24;
  } else {
    t24 = $[50];
  }
  let t25;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <IconShieldExclamation className="fillButtonIcon" />;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== t) {
    t26 = t("dissatisfaction.items.distrust.title");
    $[52] = t;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t) {
    t27 = t("dissatisfaction.items.distrust.text");
    $[54] = t;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== handleSelectOption) {
    t28 = () => handleSelectOption("distrust");
    $[56] = handleSelectOption;
    $[57] = t28;
  } else {
    t28 = $[57];
  }
  let t29;
  if ($[58] !== t26 || $[59] !== t27 || $[60] !== t28) {
    t29 = {
      analyticsParam: "retentionDissatisfactionDistrust",
      icon: t25,
      testId: "retentionDissatisfactionDistrust",
      title: t26,
      text: t27,
      onClick: t28
    };
    $[58] = t26;
    $[59] = t27;
    $[60] = t28;
    $[61] = t29;
  } else {
    t29 = $[61];
  }
  let t30;
  if ($[62] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <IconShoppingBag className="fillButtonIcon" />;
    $[62] = t30;
  } else {
    t30 = $[62];
  }
  let t31;
  if ($[63] !== t) {
    t31 = t("dissatisfaction.items.fewEshops.title");
    $[63] = t;
    $[64] = t31;
  } else {
    t31 = $[64];
  }
  let t32;
  if ($[65] !== t) {
    t32 = t("dissatisfaction.items.fewEshops.text");
    $[65] = t;
    $[66] = t32;
  } else {
    t32 = $[66];
  }
  let t33;
  if ($[67] !== handleSelectOption) {
    t33 = () => handleSelectOption("fewEshops");
    $[67] = handleSelectOption;
    $[68] = t33;
  } else {
    t33 = $[68];
  }
  let t34;
  if ($[69] !== t31 || $[70] !== t32 || $[71] !== t33) {
    t34 = {
      analyticsParam: "retentionDissatisfactionFewEshops",
      icon: t30,
      testId: "retentionDissatisfactionFewEshops",
      title: t31,
      text: t32,
      onClick: t33
    };
    $[69] = t31;
    $[70] = t32;
    $[71] = t33;
    $[72] = t34;
  } else {
    t34 = $[72];
  }
  let t35;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <IconShoppingCart className="fillButtonIcon" />;
    $[73] = t35;
  } else {
    t35 = $[73];
  }
  let t36;
  if ($[74] !== t) {
    t36 = t("dissatisfaction.items.lowLimit.title");
    $[74] = t;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  let t37;
  if ($[76] !== t) {
    t37 = t("dissatisfaction.items.lowLimit.text");
    $[76] = t;
    $[77] = t37;
  } else {
    t37 = $[77];
  }
  let t38;
  if ($[78] !== handleSelectOption) {
    t38 = () => handleSelectOption("lowLimit");
    $[78] = handleSelectOption;
    $[79] = t38;
  } else {
    t38 = $[79];
  }
  let t39;
  if ($[80] !== t36 || $[81] !== t37 || $[82] !== t38) {
    t39 = {
      analyticsParam: "retentionDissatisfactionLowLimit",
      icon: t35,
      testId: "retentionDissatisfactionLowLimit",
      title: t36,
      text: t37,
      onClick: t38
    };
    $[80] = t36;
    $[81] = t37;
    $[82] = t38;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  let t40;
  if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
    t40 = <IconGift className="fillButtonIcon" />;
    $[84] = t40;
  } else {
    t40 = $[84];
  }
  let t41;
  if ($[85] !== t) {
    t41 = t("dissatisfaction.items.firstDiscountOnly.title");
    $[85] = t;
    $[86] = t41;
  } else {
    t41 = $[86];
  }
  let t42;
  if ($[87] !== t) {
    t42 = t("dissatisfaction.items.firstDiscountOnly.text");
    $[87] = t;
    $[88] = t42;
  } else {
    t42 = $[88];
  }
  let t43;
  if ($[89] !== handleSelectOption) {
    t43 = () => handleSelectOption("firstDiscountOnly");
    $[89] = handleSelectOption;
    $[90] = t43;
  } else {
    t43 = $[90];
  }
  let t44;
  if ($[91] !== t41 || $[92] !== t42 || $[93] !== t43) {
    t44 = {
      analyticsParam: "retentionDissatisfactionFirstDiscountOnly",
      icon: t40,
      testId: "retentionDissatisfactionFirstDiscountOnly",
      title: t41,
      text: t42,
      onClick: t43
    };
    $[91] = t41;
    $[92] = t42;
    $[93] = t43;
    $[94] = t44;
  } else {
    t44 = $[94];
  }
  let t45;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <IconRewards className="fillButtonIcon" />;
    $[95] = t45;
  } else {
    t45 = $[95];
  }
  let t46;
  if ($[96] !== t) {
    t46 = t("dissatisfaction.items.fewRewards.title");
    $[96] = t;
    $[97] = t46;
  } else {
    t46 = $[97];
  }
  let t47;
  if ($[98] !== t) {
    t47 = t("dissatisfaction.items.fewRewards.text");
    $[98] = t;
    $[99] = t47;
  } else {
    t47 = $[99];
  }
  let t48;
  if ($[100] !== handleSelectOption) {
    t48 = () => handleSelectOption("fewRewards");
    $[100] = handleSelectOption;
    $[101] = t48;
  } else {
    t48 = $[101];
  }
  let t49;
  if ($[102] !== t46 || $[103] !== t47 || $[104] !== t48) {
    t49 = {
      analyticsParam: "retentionDissatisfactionFewRewards",
      icon: t45,
      testId: "retentionDissatisfactionFewRewards",
      title: t46,
      text: t47,
      onClick: t48
    };
    $[102] = t46;
    $[103] = t47;
    $[104] = t48;
    $[105] = t49;
  } else {
    t49 = $[105];
  }
  let t50;
  if ($[106] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <IconThird className="fillButtonIcon" />;
    $[106] = t50;
  } else {
    t50 = $[106];
  }
  let t51;
  if ($[107] !== t) {
    t51 = t("dissatisfaction.items.lowLimitThree.title");
    $[107] = t;
    $[108] = t51;
  } else {
    t51 = $[108];
  }
  let t52;
  if ($[109] !== t) {
    t52 = t("dissatisfaction.items.lowLimitThree.text");
    $[109] = t;
    $[110] = t52;
  } else {
    t52 = $[110];
  }
  let t53;
  if ($[111] !== handleSelectOption) {
    t53 = () => handleSelectOption("lowLimitThree");
    $[111] = handleSelectOption;
    $[112] = t53;
  } else {
    t53 = $[112];
  }
  let t54;
  if ($[113] !== t51 || $[114] !== t52 || $[115] !== t53) {
    t54 = {
      analyticsParam: "retentionDissatisfactionLowLimitThree",
      icon: t50,
      testId: "retentionDissatisfactionLowLimitThree",
      title: t51,
      text: t52,
      onClick: t53
    };
    $[113] = t51;
    $[114] = t52;
    $[115] = t53;
    $[116] = t54;
  } else {
    t54 = $[116];
  }
  let t55;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t55 = <IconChat className="fillButtonIcon" />;
    $[117] = t55;
  } else {
    t55 = $[117];
  }
  let t56;
  if ($[118] !== t) {
    t56 = t("dissatisfaction.items.other.title");
    $[118] = t;
    $[119] = t56;
  } else {
    t56 = $[119];
  }
  let t57;
  if ($[120] !== handleScrollToContact || $[121] !== t56) {
    t57 = {
      analyticsParam: "retentionDissatisfactionOther",
      icon: t55,
      testId: "retentionDissatisfactionOther",
      title: t56,
      onClick: handleScrollToContact
    };
    $[120] = handleScrollToContact;
    $[121] = t56;
    $[122] = t57;
  } else {
    t57 = $[122];
  }
  let t58;
  if ($[123] !== t24 || $[124] !== t29 || $[125] !== t34 || $[126] !== t39 || $[127] !== t44 || $[128] !== t49 || $[129] !== t54 || $[130] !== t57) {
    t58 = <div className="mx-auto mt-10 flex flex-wrap items-center justify-center gap-2 sm:w-94 lg:mt-16 lg:w-192 lg:gap-4">{[t24, t29, t34, t39, t44, t49, t54, t57].map(_temp)}</div>;
    $[123] = t24;
    $[124] = t29;
    $[125] = t34;
    $[126] = t39;
    $[127] = t44;
    $[128] = t49;
    $[129] = t54;
    $[130] = t57;
    $[131] = t58;
  } else {
    t58 = $[131];
  }
  let t59;
  if ($[132] !== sheet || $[133] !== t14 || $[134] !== t19 || $[135] !== t58) {
    t59 = <div className="px-4">{sheet}{t14}{t19}{t58}</div>;
    $[132] = sheet;
    $[133] = t14;
    $[134] = t19;
    $[135] = t58;
    $[136] = t59;
  } else {
    t59 = $[136];
  }
  return t59;
}
function _temp(button, id_0) {
  return <FilledButton key={id_0} analyticsParam={button.analyticsParam} icon={button.icon} testId={button.testId} onClick={button.onClick} className="h-20 w-full sm:w-94"><span className="block">{button.title}{button.text && <span className="block text-sm font-thin">{button.text}</span>}</span></FilledButton>;
}